import React from 'react'
import { useEffect } from 'react'
import {useDispatch, useSelector} from 'react-redux'
import { Routes, Route, BrowserRouter } from 'react-router-dom'
// @ts-ignore
import Cookies from 'js-cookie'

import { UserHome as UserHomeLegacy } from '../components/user_home/UserHome'
import { UserHome2 as UserHomeV2 } from '../components/user_home/UserHome2';

import { constants } from '../config/constants'
import {zynity_api} from '../config/external-routes'
import { Loading } from '../components/ui/loading/Loading'
import { UserProfile } from '../components/user/profile/UserProfile'
import { ZAdmin } from '../components/admin/z_admin/ZAdmin'
import { AdminRoute } from './AdminRoute'
import { UsersManage } from '../components/admin/users/user_manage/UsersManage'
import {ServicesManage} from "../components/admin/services/ServicesManage";
import {ServiceDetails} from "../components/admin/services/details/ServiceDetails";
import {OrganizationsManage} from "../components/admin/organizations/OrganizationsManage";
import {OrganizationDetails} from "../components/admin/organizations/details/OrganizationDetails";
import {CoachesManage} from "../components/admin/coaches/CoachesManage";
import {CoachDetails} from "../components/admin/coaches/details/CoachDetails";
import {AssessmentsManage} from "../components/admin/assessments/AssessmentsManage";
import {ContentEditor} from "../components/admin/content_editor/ContentEditor";
import {CoachRoute} from "./CoachRoute";
import {CoachDashboard} from "../components/coaches/CoachDashboard";
import {CoachProfile} from "../components/coaches/profile/CoachProfile";
import {CoachAgreement} from "../components/coaches/CoachAgreement";
import {Assessment} from "../components/leadership_assessment/Assessment";
import {TeamAssessment} from "../components/leadership_assessment/TeamAssessment";
import {TodayAssessment} from "../components/leadership_assessment/TodayAssessment";
import {TomorrowAssessment} from "../components/leadership_assessment/TomorrowAssessment";
import {HowLead} from "../components/user/menu/how_to_lead/HowLead";
import {NotifierApp} from "../components/user/menu/notifier_app/NotifierApp";
import {AdminHome} from "../components/organizations/admin/AdminHome";
import {OrganizationRoute} from "./OrganizationRoute";
import {OrganizationProfile} from "../components/organizations/admin/profile/OrganizationProfile";
import {ManageMembers} from "../components/organizations/admin/members/ManageMembers";
import {ManageTeams} from "../components/organizations/admin/teams/ManageTeams";
import {ManageCoaches} from "../components/organizations/admin/coaches/ManageCoaches";
import {ManageAdministrators} from "../components/organizations/admin/administrators/ManageAdministrators";
import {RemoveOrganization} from "../components/organizations/admin/remove_organization/RemoveOrganization";
import {OrganizationTeamRoute} from "./OrganizationTeamRoute";
import {CoachNotes} from "../components/organizations/teams/coach_notes/CoachNotes";
import {setLogOut, setUser, startLoading} from "../store/auth";
import {getUserOrganizations} from "../store/user_organizations";
import axios from "axios";
import {RedirectRouter} from "../helpers/RedirectRouter";
import {CnA} from "../components/organizations/teams/CnA/CnA";
import {CollabMessages} from "../components/organizations/teams/CnA/messages/CollabMessages";
import {FacilitatorDashboardRoute} from "./FacilitatorDashboardRoute";
import {Dashboard} from "../components/organizations/teams/facilitator_dashboard/Dashboard";
import {TeamProfile} from "../components/organizations/teams/facilitator_dashboard/profile/TeamProfile";
import { ManageMembers as FacilitatorDashboardManageMembers  } from "../components/organizations/teams/facilitator_dashboard/members/ManageMembers";
import { ManageCoaches as FacilitatorDashboardManageCoaches  } from "../components/organizations/teams/facilitator_dashboard/coaches/ManageCoaches";
import {ManageTools} from "../components/organizations/teams/facilitator_dashboard/tools/ManageTools";
import {RemoveTeam} from "../components/organizations/teams/facilitator_dashboard/remove/RemoveTeam";
import {
    SuiteSelection
} from "../components/organizations/teams/facilitator_dashboard/tools/suite_selection/SuiteSelection";
import {getServices} from "../store/global/services";
import {AddMember} from "../components/organizations/teams/facilitator_dashboard/members/AddMember";
import {RedirectBase64} from "../helpers/RedirectBase64";
import {LogOut} from "../components/LogOut";
import {FacilitatorDashboardRedirectHandler} from "../helpers/FacilitatorDashboardRedirectHandler";
import { TeamCalendarPage } from '../components/calendar/TeamCalendarPage';
import { PublicAuthRouter } from '../components/auth/PublicAuthRouter';
import { HelpRequestPage } from '../components/help/HelpRequestPage';
import { DocumentLibraryPage } from '../components/organizations/teams/document_library/DocumentLibraryPage';
import { EngagementWidgetPage } from '../components/engagement/EngagementWidgetPage';
import { IaLimitsPage } from '../components/engagement/ia_limits/IaLimitsPage';


const isLocalEnv = process.env.REACT_APP_ENV === constants.envs.local;

/** Optional: set `REACT_APP_AUTO_SET_DEV_TOKEN_COOKIE=true` in `.env.dev` to pre-fill the session cookie from `REACT_APP_ZYNITY_API_TOKEN_DEV_TOKEN` (skip login until the token expires or fails). */

function clearAccessTokenCookie() {
    const cookieName = constants.zynity_api_access_token_cookie_name;
    const host = window.location.hostname;
    const cookieDomains = new Set<string>();

    if (host) {
        cookieDomains.add(host);
    }
    if (host === 'zynity.com' || host.endsWith('.zynity.com')) {
        cookieDomains.add('zynity.com');
        cookieDomains.add('.zynity.com');
    }

    Cookies.remove(cookieName, { path: '/' });
    Cookies.remove(cookieName);

    cookieDomains.forEach((domain) => {
        Cookies.remove(cookieName, { path: '/', domain });
        Cookies.remove(cookieName, { domain });
    });
}

export const AppRouter = () => {

    const dispatch = useDispatch();
    const user = useSelector((state:any) => state.auth)

    const cookieName = constants.zynity_api_access_token_cookie_name;
    let access_token = Cookies.get(cookieName);

    if (
        isLocalEnv &&
        access_token === undefined &&
        process.env.REACT_APP_AUTO_SET_DEV_TOKEN_COOKIE === 'true'
    ) {
        const devToken = process.env.REACT_APP_ZYNITY_API_TOKEN_DEV_TOKEN ?? '';
        if (devToken) {
            Cookies.set(cookieName, devToken);
            access_token = Cookies.get(cookieName);
        }
    }

    useEffect(() => {
        if (!access_token) {
            dispatch(setLogOut());
            return;
        }

        dispatch(startLoading());

        axios.defaults.headers.common = {'Authorization': `Bearer ${access_token}`};
        axios.get(zynity_api.retrieve_authenticated_user)
            .then((response) => {
                dispatch(setUser({
                    ...response.data.user,
                    access_token,
                    features: response.data.features || {},
                }));
                dispatch(getUserOrganizations());
                dispatch(getServices());
            })
            .catch(() => {
                clearAccessTokenCookie();
                dispatch(setLogOut());
            });
    }, [dispatch, access_token])

    const effectiveAccessToken = access_token;
    const hasAccessToken = Boolean(effectiveAccessToken);
    const pathname = window.location.pathname;
    const lowerPathname = pathname.toLowerCase();
    const isEngagementWidgetRoute = lowerPathname === '/engagement/widget';
    const isLoginRoute = lowerPathname === '/site/login' || lowerPathname === '/login';
    const isSocialCompleteRoute = lowerPathname === '/auth/social-complete';
    const isLoginHelpRoute =
        lowerPathname === '/site/loginhelp' ||
        lowerPathname === '/loginhelp' ||
        lowerPathname === '/login-help' ||
        lowerPathname === '/reset-password' ||
        lowerPathname === '/people/resetpass' ||
        lowerPathname === '/password/reset';
    const isPublicAuthRoute = isLoginRoute || isLoginHelpRoute || (isSocialCompleteRoute && !hasAccessToken);

    useEffect(() => {
        if (hasAccessToken) return;

        const requestedPath = `${window.location.pathname}${window.location.search}${window.location.hash}`;
        const isHomeRoute = requestedPath === '/' || requestedPath === '';

        if (isPublicAuthRoute && !isSocialCompleteRoute) {
            localStorage.removeItem(constants.post_login_redirect_storage_key);
            return;
        }

        if (!isHomeRoute) {
            localStorage.setItem(constants.post_login_redirect_storage_key, requestedPath);
        } else {
            localStorage.removeItem(constants.post_login_redirect_storage_key);
        }
    }, [hasAccessToken, isPublicAuthRoute, isSocialCompleteRoute]);

    useEffect(() => {
        if (!hasAccessToken) return;
        if (!isSocialCompleteRoute) return;

        window.location.replace('/');
    }, [hasAccessToken, isSocialCompleteRoute]);

    if (isEngagementWidgetRoute) {
        return (
            <BrowserRouter>
                <Routes>
                    <Route path="/engagement/widget" element={<EngagementWidgetPage />} />
                </Routes>
            </BrowserRouter>
        );
    }

    if(isPublicAuthRoute || !hasAccessToken) {
        return <PublicAuthRouter />;
    }

    if (user.isLoading) {
        return (
            <>
                <div className="row loading-center-fixed">
                    <div className="col-12 text-center mb-4">
                        <img src={require('../assets/images/zynity_logo.png')} width="400" alt=""/>
                    </div>
                    <div className="col-12 text-center mt-4">
                        <h2>Loading...<span style={{ fontSize: '16px' }}><Loading /></span></h2>
                    </div>
                </div>
            </>
        )
    }

    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" element={<UserHomeV2 />} />
                {/* Keep explicit paths to both for testing/rollback */}
                <Route path="/user-home2" element={<UserHomeV2 />} />
                <Route path="/user-home" element={<UserHomeLegacy />} /> {/* legacy */}

                <Route path="/site/helpRequest" element={<HelpRequestPage />} />
                <Route path="/site/helprequest" element={<HelpRequestPage />} />
                <Route path="/help-request" element={<HelpRequestPage />} />
                <Route path="/helprequest" element={<HelpRequestPage />} />

                <Route path="/logout" element={<LogOut />} />
                <Route path="/user/profile" element={<UserProfile />} />
                <Route path="/admin/*" element={
                    <AdminRoute>
                        <Routes>
                            <Route path="/z-admin" element={<ZAdmin />} />
                            <Route path="/people" element={<UsersManage />} />
                            <Route path="/people/:user_id" element={<UserProfile external_user={true} read_only={true} />} />
                            <Route path="/people-update/:user_id" element={<UserProfile external_user={true} />} />

                            <Route path="/services" element={<ServicesManage />} />
                            <Route path="/services/:service_id" element={<ServiceDetails />} />
                            <Route path="/services-update/:service_id/" element={<ServiceDetails readOnly={false} />} />

                            <Route path="/assessments" element={<AssessmentsManage />} />

                            <Route path="/organizations" element={<OrganizationsManage />} />
                            <Route path="/organizations/:organization_id" element={<OrganizationDetails />} />
                            <Route path="/organizations-update/:organization_id/" element={<OrganizationDetails readOnly={false} />} />

                            <Route path="/coaches" element={<CoachesManage />} />
                            <Route path="/coaches/:coach_id" element={<CoachDetails />} />
                            <Route path="/coaches-update/:coach_id/" element={<CoachDetails readOnly={false} />} />

                            <Route path="/content-editor/:page" element={<ContentEditor />} />
                        </Routes>
                    </AdminRoute>
                } />

                <Route path="/coach/*" element={
                    <CoachRoute>
                        <Routes>
                            <Route path="/" element={<CoachDashboard />} />
                            <Route path="/certified-coach-profile-update" element={<CoachProfile />} />
                            <Route path="/agreement" element={<CoachAgreement />} />
                        </Routes>
                    </CoachRoute>
                } />

                <Route path="/leadership-assessment/*" element={
                    <Routes>
                        <Route path="/" element={<Assessment />} />
                        <Route path="/team" element={<TeamAssessment />} />
                        <Route path="/today" element={<TodayAssessment />} />
                        <Route path="/tomorrow" element={<TomorrowAssessment />} />
                    </Routes>
                } />

                <Route path="/how-lead" element={<HowLead />} />
                <Route path="/notifier-app" element={<NotifierApp />} />
                <Route path="/team-calendar" element={<TeamCalendarPage />} />
                <Route path="/engagement/widget" element={<EngagementWidgetPage />} />
                <Route path="/ia-limits" element={<IaLimitsPage />} />

                <Route path="/organizations/:organization_id/*" element={
                    <OrganizationRoute>
                        <Routes>
                            <Route path="/" element={<AdminHome />} />
                            <Route path="/profile" element={<OrganizationProfile />} />
                            <Route path="/members" element={<ManageMembers />} />
                            <Route path="/teams" element={<ManageTeams />} />
                            <Route path="/coaches" element={<ManageCoaches />} />
                            <Route path="/coaches/:coach_id" element={<CoachProfile show_logged_coach={false} />} />
                            <Route path="/administrators" element={<ManageAdministrators />} />
                            <Route path="/remove" element={<RemoveOrganization />} />

                            <Route path="/teams/:team_id/*" element={
                                <OrganizationTeamRoute>
                                    <Routes>
                                        <Route path="/coach/notes" element={<CoachNotes />} />
                                        <Route path="/CnA" element={<CnA/>} />
                                        <Route path="/collab" element={<CnA/>} />
                                        <Route path="/CnA/messages" element={<CollabMessages/>} />
                                        <Route path="/collab/messages" element={<CollabMessages/>} />
                                        <Route path="/document-library" element={<DocumentLibraryPage />} />
                                        <Route path="/CnA/:datum_id" element={<CnA/>} />
                                        <Route path="/collab/:datum_id" element={<CnA/>} />
                                    </Routes>
                                </OrganizationTeamRoute>
                            } />
                        </Routes>
                    </OrganizationRoute>
                } />

                <Route path="/facilitator-dashboard/*" element={
                    <FacilitatorDashboardRoute>
                        <Routes>
                            <Route path="/" element={<Dashboard />} />
                            <Route path="/team-profile" element={<TeamProfile />} />
                            <Route path="/manage-members" element={<FacilitatorDashboardManageMembers />} />
                                <Route path="/manage-members/add-member" element={<AddMember />} />
                            <Route path="/manage-tools" element={<ManageTools />} />
                                <Route path="/manage-tools/suite-selection" element={<SuiteSelection />} />
                            <Route path="/manage-coaches" element={<FacilitatorDashboardManageCoaches />} />
                            <Route path="/remove-team" element={<RemoveTeam />} />
                        </Routes>
                    </FacilitatorDashboardRoute>
                } />

            {/*    Slug Routes   */}
                <Route path="/coach-notes" element={<RedirectRouter />} />
                <Route path="/collab/messages" element={<RedirectBase64 />} />
                <Route path="/collab" element={<RedirectBase64 />} />
                <Route path="/facilitator-dashboard-redirect-handled" element={<FacilitatorDashboardRedirectHandler />} />
            </Routes>
        </BrowserRouter>
    )
}
